import React from "react";
import { BarChart3 } from "lucide-react";

export default function Analytics() {
  return (
    <div className="space-y-6" data-testid="analytics-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">Insights</div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Analytics</h1>
        <p className="text-sm text-slate-500 mt-1">Consumption trends, revenue and fleet-wide meter health.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-sm p-10 grid place-items-center text-center">
        <div className="max-w-md">
          <BarChart3 className="mx-auto text-brand-500 mb-4" size={40} strokeWidth={1.5} />
          <h2 className="font-heading text-lg font-semibold text-slate-800">Fleet analytics dashboards coming next</h2>
          <p className="text-sm text-slate-500 mt-2 leading-relaxed">
            You'll be able to see gas throughput per household, average signal quality across the
            fleet, low-balance forecasts, and revenue by area.
          </p>
        </div>
      </div>
    </div>
  );
}
